export default __webpack_public_path__ + "static/media/1034.2eb09f11.png";